import React, { Fragment, useEffect, useState } from 'react'
import AudioCard from '../Main/AudioCard'
import audiobook1 from "../../Assets/Images/audiobook1.png";
import audiobook2 from "../../Assets/Images/audiobook2.png";
import audiobook3 from "../../Assets/Images/audiobook3.png";
import { FaArrowRightLong } from "react-icons/fa6";
import toast from 'react-hot-toast';
import { getBooks } from '../../Services/BooksServices';
import { Link } from 'react-router-dom';


import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';



const AudioBook = () => {


    const [booksData, setBooksData] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const handleGetBooks = async () => {
        setIsLoading(true)
        let response = await getBooks("audio_book")
        if (response.statusCode === 200) {
            setBooksData(response?.response?.data?.data)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value)
            // }
            toast?.error(response?.errors)

            setIsLoading(false)
        }
        setIsLoading(false)
    }


    useEffect(() => {
        handleGetBooks();
    }, [])

    return (
        <Fragment>
            <section className=''>
                <div className="container py-100" >
                    <div className="row">
                        <div className="col">
                            <h2 className="heading">
                                Audio Books
                            </h2>
                        </div>

                        <Link to={"/books"} state={"audio_book"} className="text-dark col-auto s-14">
                            View more
                            {" "}
                            <FaArrowRightLong className='ms-2' />
                        </Link>
                    </div>


                    <div className="row justify-content-center">
                        <Swiper
                            // style={{ width: "100%", height: "250px" }}
                            modules={[Navigation, Pagination, Scrollbar, A11y]}
                            spaceBetween={1}
                            slidesPerView={5}
                            navigation
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                    // spaceBetween: 20
                                },
                                480: {
                                    slidesPerView: 1,
                                    // spaceBetween: 20

                                },
                                768: {
                                    slidesPerView: 2,
                                    // spaceBetween: 20

                                },
                                1024: {
                                    slidesPerView: 3,
                                    // spaceBetween: 20

                                },
                                1200: {
                                    slidesPerView: 3,
                                    // spaceBetween: 20

                                },
                            }}
                        // pagination={{ clickable: false }}
                        // scrollbar={{ draggable: true }}
                        >
                            {booksData.map((item, i) => (
                                <div className='col'>
                                    <SwiperSlide className='container' key={i}>
                                        <AudioCard key={i} data={item} />
                                    </SwiperSlide>
                                </div>
                            ))}
                        </Swiper>

                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default AudioBook